module.exports = __webpack_public_path__ + "243bbf284d6d253a0ee08126fff955cc.png";